module.exports = __webpack_public_path__ + "static/media/analog1.2427b4b3.jpg";